module.exports = __webpack_public_path__ + "static/icon-03aa511f409a20642a72577f213a45f9.png";